import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };

  async change(event) {
    const currency = event.target.value;

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
        },
        body: JSON.stringify({ currency: currency }),
      });

      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error al cambiar moneda:", error);
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || "";
  }
}
